import React from 'react'
import { Link } from "react-router-dom";
import web3 from "../../assets/svgs/decentralized.svg";

const InterviewTab = () => {
    return (
        <div className="w-[100%] bg-main-blue h-[22%]  mt-16 rounded-2xl grid grid-cols-[80%_20%] ">
          <div className="flex flex-col justify-between h-[100%] pl-10 text-white font-light">
            <div>
              <p className="text-3xl mt-2">Interview Practice Session</p>
            </div>
            <div className="flex w-[45%] justify-between">
              {tabsData.map((tab, i) => (
                <Link
                  key={i}
                  id={tab.id}
                  to={`/${tab.id}`}
                  className="pb-1 active:border-b-2 active:border-b-white"
                >
                  {tab.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <img src={web3} alt="" />
          </div>
        </div>
      );
}

export default InterviewTab

const tabsData:{
    id:string,
    label:string,
  }[] = [
    {
        id: "interview",
        label: "Book a session",
    },
    {
        id: "bookings",
        label: "Track your bookings",
    }
  ]